import { api } from '../lib/api';

export interface AuditLogEntry {
  id: string;
  userId: string | null;
  action: string;
  method: string;
  path: string;
  statusCode: number;
  ipAddress: string | null;
  userAgent: string | null;
  metadata?: {
    messageId?: string;
    senderId?: string;
    senderName?: string;
    receiverId?: string;
    receiverName?: string;
    messageLength?: number;
    eventId?: string;
    eventTitle?: string;
    rsvpStatus?: 'attending' | 'maybe' | 'not_attending';
    reminderType?: string;
    postId?: string;
    postTitle?: string;
    [key: string]: string | number | boolean | null | undefined;
  } | null;
  createdAt: string;
  user: {
    id: string;
    email: string;
    name: string;
  } | null;
}

export interface AuditLogListResponse {
  items: AuditLogEntry[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
    hasMore: boolean;
  };
}

export interface AuditLogFilters {
  page?: number;
  limit?: number;
  userId?: string;
  userName?: string;
  method?: string;
  path?: string;
  action?: string;
  entryType?: 'action' | 'request' | 'all';
}

export const getAuditLogs = async (filters: AuditLogFilters = {}): Promise<AuditLogListResponse> => {
  const response = await api.get<AuditLogListResponse>('/admin/audit-logs', {
    params: filters,
  });

  return response.data;
};
